import { render, staticRenderFns } from "./communityserviceuser.vue?vue&type=template&id=709e3d10&scoped=true&"
import script from "./communityserviceuser.vue?vue&type=script&lang=js&"
export * from "./communityserviceuser.vue?vue&type=script&lang=js&"
import style0 from "./communityserviceuser.vue?vue&type=style&index=0&id=709e3d10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709e3d10",
  null
  
)

export default component.exports